export var D2CRefundPolicyRuleTimeUnit;
(function (D2CRefundPolicyRuleTimeUnit) {
    D2CRefundPolicyRuleTimeUnit["DAYS"] = "DAYS";
    D2CRefundPolicyRuleTimeUnit["HOURS"] = "HOURS";
})(D2CRefundPolicyRuleTimeUnit || (D2CRefundPolicyRuleTimeUnit = {}));
